/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date; output: Date; }
};

export type AddressCandidate = {
  __typename?: 'AddressCandidate';
  city: Scalars['String']['output'];
  cityKana: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  prefectureKana: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  streetAddressKana: Scalars['String']['output'];
};

export type Admin = {
  __typename?: 'Admin';
  performanceTrend: AdminPerformanceTrend;
  purchase?: Maybe<AdminPurchaseDetail>;
  purchases: AdminPurchaseConnection;
  restaurant?: Maybe<AdminRestaurant>;
  restaurantFilterMaster: AdminRestaurantFilterMaster;
  restaurantListSummary: AdminRestaurantListSummary;
  restaurants: AdminRestaurantConnection;
  settingTerms: AdminSettingTerms;
  ticketFilters: Array<AdminTicketFilter>;
  ticketUsageSummary: AdminTicketUsageSummary;
  user?: Maybe<AdminUser>;
  users: Array<AdminUser>;
};


export type AdminPerformanceTrendArgs = {
  input: AdminPerformanceTrendInput;
};


export type AdminPurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type AdminPurchasesArgs = {
  input: AdminPurchasesInput;
};


export type AdminRestaurantArgs = {
  id: Scalars['ID']['input'];
};


export type AdminRestaurantListSummaryArgs = {
  input: AdminRestaurantListSummaryInput;
};


export type AdminRestaurantsArgs = {
  input: AdminRestaurantsInput;
};


export type AdminTicketUsageSummaryArgs = {
  input: AdminTicketUsageSummaryInput;
};


export type AdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type AdminUsersArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum AdminContractPlan {
  Standard = 'STANDARD',
  Suspended = 'SUSPENDED'
}

export enum AdminPerformancePeriodUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type AdminPerformanceTrend = {
  __typename?: 'AdminPerformanceTrend';
  periodUnit: AdminPerformancePeriodUnit;
  rows: Array<AdminPerformanceTrendRow>;
};

export type AdminPerformanceTrendInput = {
  date: Scalars['String']['input'];
  periodUnit: AdminPerformancePeriodUnit;
  ticketFilterId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminPerformanceTrendRow = {
  __typename?: 'AdminPerformanceTrendRow';
  distributionGrossAmount: Scalars['Int']['output'];
  distributionGrossDiff: Scalars['Int']['output'];
  periodLabel: Scalars['String']['output'];
  registeredShopCount: Scalars['Int']['output'];
  registeredShopDiff: Scalars['Int']['output'];
  revenueAmount: Scalars['Int']['output'];
  revenueDiff: Scalars['Int']['output'];
  soldTicketCount: Scalars['Int']['output'];
  soldTicketDiff: Scalars['Int']['output'];
};

export type AdminPurchase = {
  __typename?: 'AdminPurchase';
  id: Scalars['ID']['output'];
  purchaseCode: Scalars['String']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
  ticket: Ticket;
  transactionType: AdminPurchaseTransactionType;
};

export type AdminPurchaseConnection = {
  __typename?: 'AdminPurchaseConnection';
  edges: Array<AdminPurchaseEdge>;
  nodes: Array<AdminPurchase>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminPurchaseDetail = {
  __typename?: 'AdminPurchaseDetail';
  id: Scalars['ID']['output'];
  purchaseCode: Scalars['String']['output'];
  purchaser: AdminPurchaseDetailPurchaser;
  ticket: Ticket;
  timeline: Array<AdminPurchaseTimelineItem>;
};

export type AdminPurchaseDetailPurchaser = {
  __typename?: 'AdminPurchaseDetailPurchaser';
  email: Scalars['String']['output'];
  type: AdminPurchasePurchaserType;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AdminPurchaseEdge = {
  __typename?: 'AdminPurchaseEdge';
  cursor: Scalars['String']['output'];
  node: AdminPurchase;
};

export enum AdminPurchasePurchaserType {
  Authenticated = 'AUTHENTICATED',
  Guest = 'GUEST'
}

export type AdminPurchaseTimelineItem = {
  __typename?: 'AdminPurchaseTimelineItem';
  occurredAt: Scalars['DateTime']['output'];
  paymentMethod: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  settlementAmount: Scalars['Int']['output'];
  ticketPrice: Scalars['Int']['output'];
  transactionType: AdminPurchaseTransactionType;
};

export enum AdminPurchaseTransactionType {
  Purchase = 'PURCHASE',
  Refunded = 'REFUNDED',
  Used = 'USED'
}

export type AdminPurchasesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<AdminPurchaseTransactionType>;
};

export type AdminRefundPurchaseError = {
  __typename?: 'AdminRefundPurchaseError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type AdminRefundPurchaseInput = {
  purchaseId: Scalars['ID']['input'];
};

export type AdminRefundPurchaseResult = AdminRefundPurchaseError | AdminRefundPurchaseSuccess;

export type AdminRefundPurchaseSuccess = {
  __typename?: 'AdminRefundPurchaseSuccess';
  purchase: AdminRefundPurchaseSuccessPurchase;
  refundedTimelineItem: AdminPurchaseTimelineItem;
};

export type AdminRefundPurchaseSuccessPurchase = {
  __typename?: 'AdminRefundPurchaseSuccessPurchase';
  id: Scalars['ID']['output'];
  purchaseCode: Scalars['String']['output'];
};

export type AdminRestaurant = {
  __typename?: 'AdminRestaurant';
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhoneNumber: Scalars['String']['output'];
  contractPlan: AdminContractPlan;
  id: Scalars['ID']['output'];
  monthlySalesAmount: Scalars['Int']['output'];
  operatingCompanyName: Scalars['String']['output'];
  salesFeeRatePercent: Scalars['Int']['output'];
  salesSummary: AdminRestaurantSalesSummary;
  salesTrend: AdminRestaurantSalesTrend;
  shop: Shop;
  ticket?: Maybe<Ticket>;
  ticketListSummary: AdminRestaurantTicketListSummary;
  tickets: AdminRestaurantTicketConnection;
};


export type AdminRestaurantSalesSummaryArgs = {
  input: AdminRestaurantSalesSummaryInput;
};


export type AdminRestaurantSalesTrendArgs = {
  input: AdminRestaurantSalesTrendInput;
};


export type AdminRestaurantTicketArgs = {
  id: Scalars['ID']['input'];
};


export type AdminRestaurantTicketListSummaryArgs = {
  input: AdminRestaurantTicketListSummaryInput;
};


export type AdminRestaurantTicketsArgs = {
  input: AdminRestaurantTicketsInput;
};

export type AdminRestaurantConnection = {
  __typename?: 'AdminRestaurantConnection';
  edges: Array<AdminRestaurantEdge>;
  nodes: Array<AdminRestaurant>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminRestaurantEdge = {
  __typename?: 'AdminRestaurantEdge';
  cursor: Scalars['String']['output'];
  node: AdminRestaurant;
};

export type AdminRestaurantFilterContractPlan = {
  __typename?: 'AdminRestaurantFilterContractPlan';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AdminRestaurantFilterMaster = {
  __typename?: 'AdminRestaurantFilterMaster';
  contractPlans: Array<AdminRestaurantFilterContractPlan>;
  prefectures: Array<AdminRestaurantFilterPrefecture>;
};

export type AdminRestaurantFilterPrefecture = {
  __typename?: 'AdminRestaurantFilterPrefecture';
  areaCode: Scalars['String']['output'];
  areaName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AdminRestaurantListSummary = {
  __typename?: 'AdminRestaurantListSummary';
  registeredRestaurantCount: Scalars['Int']['output'];
  registeredRestaurantDiffFromPreviousMonth: Scalars['Int']['output'];
};

export type AdminRestaurantListSummaryInput = {
  targetMonth: Scalars['String']['input'];
};

export type AdminRestaurantSalesSummary = {
  __typename?: 'AdminRestaurantSalesSummary';
  availableTicketCount: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  purchasedUnusedTicketCount: Scalars['Int']['output'];
  usedTicketCount: Scalars['Int']['output'];
};

export type AdminRestaurantSalesSummaryInput = {
  date: Scalars['String']['input'];
  periodUnit?: InputMaybe<AdminPerformancePeriodUnit>;
};

export type AdminRestaurantSalesTrend = {
  __typename?: 'AdminRestaurantSalesTrend';
  rows: Array<AdminRestaurantSalesTrendRow>;
};

export type AdminRestaurantSalesTrendInput = {
  anchorDate: Scalars['String']['input'];
  periodUnit: AdminPerformancePeriodUnit;
};

export type AdminRestaurantSalesTrendRow = {
  __typename?: 'AdminRestaurantSalesTrendRow';
  distributionGrossAmount: Scalars['Int']['output'];
  distributionGrossDiff: Scalars['Int']['output'];
  periodLabel: Scalars['String']['output'];
  revenueAmount: Scalars['Int']['output'];
  revenueDiff: Scalars['Int']['output'];
  soldTicketCount: Scalars['Int']['output'];
  soldTicketDiff: Scalars['Int']['output'];
};

export type AdminRestaurantTicketConnection = {
  __typename?: 'AdminRestaurantTicketConnection';
  edges: Array<AdminRestaurantTicketEdge>;
  nodes: Array<Ticket>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminRestaurantTicketEdge = {
  __typename?: 'AdminRestaurantTicketEdge';
  cursor: Scalars['String']['output'];
  node: Ticket;
};

export type AdminRestaurantTicketListSummary = {
  __typename?: 'AdminRestaurantTicketListSummary';
  monthlySalesAmount: Scalars['Int']['output'];
  monthlySalesDiffFromPreviousMonth: Scalars['Int']['output'];
};

export type AdminRestaurantTicketListSummaryInput = {
  targetMonth: Scalars['String']['input'];
};

export type AdminRestaurantTicketsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TicketPublicationStatus>;
};

export type AdminRestaurantsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  contractPlan?: InputMaybe<AdminContractPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  prefectureCode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdminRestaurantsSort>;
};

export enum AdminRestaurantsSort {
  MonthlySalesAsc = 'MONTHLY_SALES_ASC',
  MonthlySalesDesc = 'MONTHLY_SALES_DESC',
  SalesFeeRateAsc = 'SALES_FEE_RATE_ASC',
  SalesFeeRateDesc = 'SALES_FEE_RATE_DESC'
}

export type AdminSettingTerms = {
  __typename?: 'AdminSettingTerms';
  privacyPolicy: Scalars['String']['output'];
  termsOfService: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminTicketFilter = {
  __typename?: 'AdminTicketFilter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdminTicketUsageSummary = {
  __typename?: 'AdminTicketUsageSummary';
  availableTickets: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  purchasedUnusedTickets: Scalars['Int']['output'];
  usedTickets: Scalars['Int']['output'];
};

export type AdminTicketUsageSummaryInput = {
  date: Scalars['String']['input'];
  periodUnit?: InputMaybe<AdminPerformancePeriodUnit>;
};

export type AdminUpdateRestaurantContractPlanError = {
  __typename?: 'AdminUpdateRestaurantContractPlanError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type AdminUpdateRestaurantContractPlanInput = {
  contractPlan: AdminContractPlan;
  restaurantId: Scalars['ID']['input'];
};

export type AdminUpdateRestaurantContractPlanResult = AdminRestaurant | AdminUpdateRestaurantContractPlanError;

export type AdminUpdateRestaurantSalesFeeError = {
  __typename?: 'AdminUpdateRestaurantSalesFeeError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type AdminUpdateRestaurantSalesFeeInput = {
  restaurantId: Scalars['ID']['input'];
  salesFeeRatePercent: Scalars['Int']['input'];
};

export type AdminUpdateRestaurantSalesFeeResult = AdminRestaurant | AdminUpdateRestaurantSalesFeeError;

export type AdminUpdateTicketStatusError = {
  __typename?: 'AdminUpdateTicketStatusError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type AdminUpdateTicketStatusInput = {
  restaurantId: Scalars['ID']['input'];
  status: TicketPublicationStatus;
  ticketId: Scalars['ID']['input'];
};

export type AdminUpdateTicketStatusResult = AdminUpdateTicketStatusError | Ticket;

export type AdminUser = {
  __typename?: 'AdminUser';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Area = {
  __typename?: 'Area';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  prefectures: Array<Prefecture>;
};


export type AreaLabelArgs = {
  lang?: InputMaybe<SupportedLanguage>;
};

export type CompleteGuestPurchaseTicketCheckoutError = {
  __typename?: 'CompleteGuestPurchaseTicketCheckoutError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CompleteGuestPurchaseTicketCheckoutInput = {
  langCode: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type CompleteGuestPurchaseTicketCheckoutResult = CompleteGuestPurchaseTicketCheckoutError | CompleteGuestPurchaseTicketCheckoutSuccess;

export type CompleteGuestPurchaseTicketCheckoutSuccess = {
  __typename?: 'CompleteGuestPurchaseTicketCheckoutSuccess';
  purchase: Purchase;
  ticketAccessToken: Scalars['String']['output'];
};

export type CompletePurchaseTicketCheckoutError = {
  __typename?: 'CompletePurchaseTicketCheckoutError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CompletePurchaseTicketCheckoutInput = {
  langCode: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type CompletePurchaseTicketCheckoutResult = CompletePurchaseTicketCheckoutError | Purchase;

export type CreateGuestPurchaseCheckoutSessionError = {
  __typename?: 'CreateGuestPurchaseCheckoutSessionError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CreateGuestPurchaseCheckoutSessionInput = {
  langCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  restaurantId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};

export type CreateGuestPurchaseCheckoutSessionResult = CreateGuestPurchaseCheckoutSessionError | CreateGuestPurchaseCheckoutSessionSuccess;

export type CreateGuestPurchaseCheckoutSessionSuccess = {
  __typename?: 'CreateGuestPurchaseCheckoutSessionSuccess';
  clientSecret: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type CreatePurchaseCheckoutSessionError = {
  __typename?: 'CreatePurchaseCheckoutSessionError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CreatePurchaseCheckoutSessionInput = {
  langCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  restaurantId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};

export type CreatePurchaseCheckoutSessionResult = CreatePurchaseCheckoutSessionError | CreatePurchaseCheckoutSessionSuccess;

export type CreatePurchaseCheckoutSessionSuccess = {
  __typename?: 'CreatePurchaseCheckoutSessionSuccess';
  clientSecret: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type CreateTenantAccountError = {
  __typename?: 'CreateTenantAccountError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CreateTenantAccountInput = {
  buildingName?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhoneNumber: Scalars['String']['input'];
  operatingCompanyName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
  shopEmail: Scalars['String']['input'];
  shopName: Scalars['String']['input'];
  shopPhoneNumber: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type CreateTenantAccountResult = CreateTenantAccountError | Restaurant;

export type CreateTenantTicketError = {
  __typename?: 'CreateTenantTicketError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CreateTenantTicketInput = {
  availableWeekdays?: InputMaybe<Array<TicketAvailableWeekday>>;
  dailyStock: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  expiryDays: Scalars['Int']['input'];
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  maxPartySize: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  pricingTiers: Array<CreateTenantTicketPricingTierInput>;
  purchaseTimeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  purchaseTimeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
  status: TicketPublicationStatus;
  validTimeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  validTimeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTenantTicketPricingTierInput = {
  pricePerPerson: Scalars['Int']['input'];
  upToQuantity: Scalars['Int']['input'];
};

export type CreateTenantTicketResult = CreateTenantTicketError | Ticket;

export type DeleteAccountError = {
  __typename?: 'DeleteAccountError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DeleteAccountInput = {
  confirmDeletion: Scalars['Boolean']['input'];
};

export type DeleteAccountResult = DeleteAccountError | DeleteAccountSuccess;

export type DeleteAccountSuccess = {
  __typename?: 'DeleteAccountSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteSavedCardsError = {
  __typename?: 'DeleteSavedCardsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DeleteSavedCardsResult = DeleteSavedCardsError | DeleteSavedCardsSuccess;

export type DeleteSavedCardsSuccess = {
  __typename?: 'DeleteSavedCardsSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteTenantMemberError = {
  __typename?: 'DeleteTenantMemberError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DeleteTenantMemberResult = {
  __typename?: 'DeleteTenantMemberResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteTenantMemberUnion = DeleteTenantMemberError | DeleteTenantMemberResult;

export type DeleteTenantTicketError = {
  __typename?: 'DeleteTenantTicketError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DeleteTenantTicketResult = {
  __typename?: 'DeleteTenantTicketResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteTenantTicketUnion = DeleteTenantTicketError | DeleteTenantTicketResult;

export type DuplicateTenantTicketError = {
  __typename?: 'DuplicateTenantTicketError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DuplicateTenantTicketInput = {
  ticketId: Scalars['ID']['input'];
};

export type DuplicateTenantTicketResult = DuplicateTenantTicketError | Ticket;

export enum ErrorCode {
  Aborted = 'ABORTED',
  AlreadyExists = 'ALREADY_EXISTS',
  Cancelled = 'CANCELLED',
  DataLoss = 'DATA_LOSS',
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  FailedPrecondition = 'FAILED_PRECONDITION',
  Internal = 'INTERNAL',
  InvalidArgument = 'INVALID_ARGUMENT',
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  OutOfRange = 'OUT_OF_RANGE',
  PermissionDenied = 'PERMISSION_DENIED',
  ResourceExhausted = 'RESOURCE_EXHAUSTED',
  Unauthenticated = 'UNAUTHENTICATED',
  Unavailable = 'UNAVAILABLE',
  Unimplemented = 'UNIMPLEMENTED',
  Unknown = 'UNKNOWN'
}

export type GrantAdminRoleByEmailError = {
  __typename?: 'GrantAdminRoleByEmailError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type GrantAdminRoleByEmailInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GrantAdminRoleByEmailResult = AdminUser | GrantAdminRoleByEmailError;

export type GrantAdminRoleError = {
  __typename?: 'GrantAdminRoleError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type GrantAdminRoleInput = {
  userId: Scalars['ID']['input'];
};

export type GrantAdminRoleResult = AdminUser | GrantAdminRoleError;

export type Guest = {
  __typename?: 'Guest';
  purchaseCheckoutSessionStatus: GuestPurchaseCheckoutSessionStatusResult;
  purchasedTicket: Purchase;
};


export type GuestPurchaseCheckoutSessionStatusArgs = {
  sessionId: Scalars['String']['input'];
};


export type GuestPurchasedTicketArgs = {
  ticketAccessToken: Scalars['String']['input'];
};

export type GuestPurchaseCheckoutSessionStatus = {
  __typename?: 'GuestPurchaseCheckoutSessionStatus';
  clientSecret?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  ticketAccessToken?: Maybe<Scalars['String']['output']>;
};

export type GuestPurchaseCheckoutSessionStatusError = {
  __typename?: 'GuestPurchaseCheckoutSessionStatusError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type GuestPurchaseCheckoutSessionStatusResult = GuestPurchaseCheckoutSessionStatus | GuestPurchaseCheckoutSessionStatusError;

export type InviteMemberInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role: TenantMembershipRole;
};

export type InviteTenantMemberError = {
  __typename?: 'InviteTenantMemberError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type InviteTenantMemberResult = InviteTenantMemberError | TenantMember;

export type MarkPurchaseUsedError = {
  __typename?: 'MarkPurchaseUsedError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type MarkPurchaseUsedInput = {
  purchaseId: Scalars['ID']['input'];
};

export type MarkPurchaseUsedResult = MarkPurchaseUsedError | TenantPurchase;

export type Me = {
  __typename?: 'Me';
  email: Scalars['String']['output'];
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  purchasedTicket?: Maybe<Purchase>;
  purchasedTickets: PurchaseConnection;
  savedCards: Array<SavedCard>;
};


export type MePurchasedTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MePurchasedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PurchasedTicketStatus>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adminRefundPurchase: AdminRefundPurchaseResult;
  adminUpdateRestaurantContractPlan: AdminUpdateRestaurantContractPlanResult;
  adminUpdateRestaurantSalesFee: AdminUpdateRestaurantSalesFeeResult;
  adminUpdateTicketStatus: AdminUpdateTicketStatusResult;
  completeGuestPurchaseTicketCheckout: CompleteGuestPurchaseTicketCheckoutResult;
  completePurchaseTicketCheckout: CompletePurchaseTicketCheckoutResult;
  createGuestPurchaseCheckoutSession: CreateGuestPurchaseCheckoutSessionResult;
  createPurchaseCheckoutSession: CreatePurchaseCheckoutSessionResult;
  createTenantAccount: CreateTenantAccountResult;
  createTenantTicket: CreateTenantTicketResult;
  deleteAccount: DeleteAccountResult;
  deleteSavedCards: DeleteSavedCardsResult;
  deleteTenantMember: DeleteTenantMemberUnion;
  deleteTenantTicket: DeleteTenantTicketUnion;
  duplicateTenantTicket: DuplicateTenantTicketResult;
  grantAdminRole: GrantAdminRoleResult;
  grantAdminRoleByEmail: GrantAdminRoleByEmailResult;
  inviteTenantMember: InviteTenantMemberResult;
  markPurchaseUsed: MarkPurchaseUsedResult;
  previewTicketTranslations: PreviewTicketTranslationsResult;
  promoteTenantManager: PromoteTenantManagerUnion;
  revokeAdminRole: RevokeAdminRoleResult;
  saveCard: SaveCardResult;
  toggleTicketActive: ToggleTicketActiveResult;
  updateAdminSettingTerms: UpdateAdminSettingTermsResult;
  updateAdminUser: UpdateAdminUserResult;
  updateCheckoutSessionTicketRecipientEmail: UpdateCheckoutSessionTicketRecipientEmailResult;
  updateTenantMember: UpdateTenantMemberResult;
  updateTenantShopSettings: UpdateTenantShopSettingsResult;
  updateTenantTicket: UpdateTenantTicketResult;
  updateTenantTicketSettings: UpdateTenantTicketSettingsResult;
  useGuestTicketWithCode: UseGuestTicketWithCodeResult;
  useTicketWithCode: UseTicketWithCodeResult;
};


export type MutationAdminRefundPurchaseArgs = {
  input: AdminRefundPurchaseInput;
};


export type MutationAdminUpdateRestaurantContractPlanArgs = {
  input: AdminUpdateRestaurantContractPlanInput;
};


export type MutationAdminUpdateRestaurantSalesFeeArgs = {
  input: AdminUpdateRestaurantSalesFeeInput;
};


export type MutationAdminUpdateTicketStatusArgs = {
  input: AdminUpdateTicketStatusInput;
};


export type MutationCompleteGuestPurchaseTicketCheckoutArgs = {
  input: CompleteGuestPurchaseTicketCheckoutInput;
};


export type MutationCompletePurchaseTicketCheckoutArgs = {
  input: CompletePurchaseTicketCheckoutInput;
};


export type MutationCreateGuestPurchaseCheckoutSessionArgs = {
  input: CreateGuestPurchaseCheckoutSessionInput;
};


export type MutationCreatePurchaseCheckoutSessionArgs = {
  input: CreatePurchaseCheckoutSessionInput;
};


export type MutationCreateTenantAccountArgs = {
  input: CreateTenantAccountInput;
};


export type MutationCreateTenantTicketArgs = {
  input: CreateTenantTicketInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteTenantMemberArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationDeleteTenantTicketArgs = {
  ticketId: Scalars['ID']['input'];
};


export type MutationDuplicateTenantTicketArgs = {
  input: DuplicateTenantTicketInput;
};


export type MutationGrantAdminRoleArgs = {
  input: GrantAdminRoleInput;
};


export type MutationGrantAdminRoleByEmailArgs = {
  input: GrantAdminRoleByEmailInput;
};


export type MutationInviteTenantMemberArgs = {
  input: InviteMemberInput;
};


export type MutationMarkPurchaseUsedArgs = {
  input: MarkPurchaseUsedInput;
};


export type MutationPreviewTicketTranslationsArgs = {
  input: PreviewTicketTranslationsInput;
};


export type MutationPromoteTenantManagerArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationRevokeAdminRoleArgs = {
  input: RevokeAdminRoleInput;
};


export type MutationSaveCardArgs = {
  input: SaveCardInput;
};


export type MutationToggleTicketActiveArgs = {
  status: TicketPublicationStatus;
  ticketId: Scalars['ID']['input'];
};


export type MutationUpdateAdminSettingTermsArgs = {
  input: UpdateAdminSettingTermsInput;
};


export type MutationUpdateAdminUserArgs = {
  input: UpdateAdminUserInput;
};


export type MutationUpdateCheckoutSessionTicketRecipientEmailArgs = {
  input: UpdateCheckoutSessionTicketRecipientEmailInput;
};


export type MutationUpdateTenantMemberArgs = {
  input: UpdateMemberInput;
};


export type MutationUpdateTenantShopSettingsArgs = {
  input: UpdateShopSettingsInput;
};


export type MutationUpdateTenantTicketArgs = {
  input: UpdateTenantTicketInput;
};


export type MutationUpdateTenantTicketSettingsArgs = {
  input: UpdateTicketSettingsInput;
};


export type MutationUseGuestTicketWithCodeArgs = {
  input: UseGuestTicketWithCodeInput;
};


export type MutationUseTicketWithCodeArgs = {
  input: UseTicketWithCodeInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PaymentMethod {
  ApplePay = 'APPLE_PAY',
  CreditCard = 'CREDIT_CARD',
  GooglePay = 'GOOGLE_PAY',
  Paypay = 'PAYPAY'
}

export type Prefecture = {
  __typename?: 'Prefecture';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};


export type PrefectureLabelArgs = {
  lang?: InputMaybe<SupportedLanguage>;
};

export type PreviewTicketTranslationsError = {
  __typename?: 'PreviewTicketTranslationsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type PreviewTicketTranslationsInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PreviewTicketTranslationsPayload = {
  __typename?: 'PreviewTicketTranslationsPayload';
  translations: Array<TicketTextTranslationPreviewItem>;
};

export type PreviewTicketTranslationsResult = PreviewTicketTranslationsError | PreviewTicketTranslationsPayload;

export type PromoteTenantManagerError = {
  __typename?: 'PromoteTenantManagerError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type PromoteTenantManagerResult = {
  __typename?: 'PromoteTenantManagerResult';
  success: Scalars['Boolean']['output'];
};

export type PromoteTenantManagerUnion = PromoteTenantManagerError | PromoteTenantManagerResult;

export type Purchase = {
  __typename?: 'Purchase';
  customerEmail: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
  referenceCode: Scalars['String']['output'];
  status: PurchaseStatus;
  ticket: Ticket;
  ticketPrice: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseCheckoutSessionStatus = {
  __typename?: 'PurchaseCheckoutSessionStatus';
  clientSecret?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  purchaseId?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type PurchaseCheckoutSessionStatusError = {
  __typename?: 'PurchaseCheckoutSessionStatusError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type PurchaseCheckoutSessionStatusResult = PurchaseCheckoutSessionStatus | PurchaseCheckoutSessionStatusError;

export type PurchaseConnection = {
  __typename?: 'PurchaseConnection';
  edges: Array<PurchaseEdge>;
  pageInfo: PurchasePageInfo;
};

export type PurchaseEdge = {
  __typename?: 'PurchaseEdge';
  cursor: Scalars['String']['output'];
  node: Purchase;
};

export type PurchaseForVerificationError = {
  __typename?: 'PurchaseForVerificationError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type PurchaseForVerificationResult = PurchaseForVerificationError | TenantPurchase;

export type PurchasePageInfo = {
  __typename?: 'PurchasePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export enum PurchaseStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export enum PurchasedTicketStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Used = 'USED'
}

export type Query = {
  __typename?: 'Query';
  admin: Admin;
  areas: Array<Area>;
  guest: Guest;
  me: Me;
  purchaseCheckoutSessionStatus: PurchaseCheckoutSessionStatusResult;
  restaurant: Restaurant;
  searchAddressByPostalCode: SearchAddressByPostalCodeResult;
  tenant: Tenant;
  ticket: Ticket;
  tickets: TicketConnection;
};


export type QueryPurchaseCheckoutSessionStatusArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryRestaurantArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchAddressByPostalCodeArgs = {
  postalCode: Scalars['String']['input'];
};


export type QueryTicketArgs = {
  restaurantId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};


export type QueryTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  areaId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Restaurant = {
  __typename?: 'Restaurant';
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhoneNumber: Scalars['String']['output'];
  contractPlan: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operatingCompanyName: Scalars['String']['output'];
  shop: Shop;
  tickets: Array<Ticket>;
};

export type RevokeAdminRoleError = {
  __typename?: 'RevokeAdminRoleError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type RevokeAdminRoleInput = {
  userId: Scalars['ID']['input'];
};

export type RevokeAdminRoleResult = RevokeAdminRoleError | RevokeAdminRoleSuccess;

export type RevokeAdminRoleSuccess = {
  __typename?: 'RevokeAdminRoleSuccess';
  success: Scalars['Boolean']['output'];
};

export type SalesReportFilter = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveCardError = {
  __typename?: 'SaveCardError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type SaveCardInput = {
  paymentMethodId: Scalars['ID']['input'];
};

export type SaveCardResult = SaveCardError | SaveCardSuccess;

export type SaveCardSuccess = {
  __typename?: 'SaveCardSuccess';
  brand: Scalars['String']['output'];
  cardId: Scalars['ID']['output'];
  expiryMonth: Scalars['Int']['output'];
  expiryYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
};

export type SavedCard = {
  __typename?: 'SavedCard';
  brand: Scalars['String']['output'];
  expiryMonth: Scalars['Int']['output'];
  expiryYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
};

export type SearchAddressByPostalCodeError = {
  __typename?: 'SearchAddressByPostalCodeError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type SearchAddressByPostalCodeResult = SearchAddressByPostalCodeError | SearchAddressByPostalCodeSuccess;

export type SearchAddressByPostalCodeSuccess = {
  __typename?: 'SearchAddressByPostalCodeSuccess';
  addresses: Array<AddressCandidate>;
};

export type Shop = {
  __typename?: 'Shop';
  buildingName?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  restaurant: Restaurant;
  streetAddress: Scalars['String']['output'];
  verificationCode?: Maybe<Scalars['String']['output']>;
  verificationMethod: TicketVerificationMethod;
};

export enum SupportedLanguage {
  En = 'EN',
  Ja = 'JA',
  Ko = 'KO',
  ZhHans = 'ZH_HANS',
  ZhHant = 'ZH_HANT'
}

export type Tenant = {
  __typename?: 'Tenant';
  currentMember?: Maybe<TenantMember>;
  member?: Maybe<TenantMember>;
  members: Array<TenantMember>;
  purchase: PurchaseForVerificationResult;
  purchases: TenantPurchaseConnection;
  restaurant: Restaurant;
  salesReport: TenantSalesReport;
  ticket?: Maybe<Ticket>;
  tickets: TenantTicketConnection;
};


export type TenantMemberArgs = {
  id: Scalars['ID']['input'];
};


export type TenantPurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type TenantPurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TenantPurchaseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type TenantSalesReportArgs = {
  filter: SalesReportFilter;
};


export type TenantTicketArgs = {
  id: Scalars['ID']['input'];
};


export type TenantTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TenantTicketFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantMember = {
  __typename?: 'TenantMember';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: TenantMembershipRole;
  status: TenantMemberStatus;
};

export enum TenantMemberStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum TenantMembershipRole {
  Manager = 'MANAGER',
  Staff = 'STAFF'
}

export type TenantPurchase = {
  __typename?: 'TenantPurchase';
  code: Scalars['String']['output'];
  customerEmail: Scalars['String']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
  status: TicketStatus;
  ticket?: Maybe<Ticket>;
  ticketPrice: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TenantPurchaseConnection = {
  __typename?: 'TenantPurchaseConnection';
  edges: Array<TenantPurchaseEdge>;
  nodes: Array<TenantPurchase>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantPurchaseEdge = {
  __typename?: 'TenantPurchaseEdge';
  cursor: Scalars['String']['output'];
  node: TenantPurchase;
};

export type TenantPurchaseFilter = {
  purchasedAtEnd?: InputMaybe<Scalars['String']['input']>;
  purchasedAtStart?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TicketStatus>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};

export type TenantSale = {
  __typename?: 'TenantSale';
  amount: Scalars['Int']['output'];
  customerEmail: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
  status: PurchaseStatus;
  ticketName: Scalars['String']['output'];
};

export type TenantSalesReport = {
  __typename?: 'TenantSalesReport';
  sales: Array<TenantSale>;
  summary: TenantSalesSummary;
};

export type TenantSalesSummary = {
  __typename?: 'TenantSalesSummary';
  amountChange: Scalars['Int']['output'];
  averageValue: Scalars['Int']['output'];
  previousPeriodAmount: Scalars['Int']['output'];
  previousPeriodTickets: Scalars['Int']['output'];
  ticketsChange: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalTickets: Scalars['Int']['output'];
};

export type TenantTicketConnection = {
  __typename?: 'TenantTicketConnection';
  edges: Array<TenantTicketEdge>;
  nodes: Array<Ticket>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantTicketEdge = {
  __typename?: 'TenantTicketEdge';
  cursor: Scalars['String']['output'];
  node: Ticket;
};

export type TenantTicketFilter = {
  status?: InputMaybe<TicketPublicationStatus>;
};

export type TenantTicketVerification = {
  __typename?: 'TenantTicketVerification';
  code: Scalars['String']['output'];
  customerEmail: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  qrCodeUrl?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  restaurant: Restaurant;
  status: TicketStatus;
  ticket: Ticket;
  totalAmount: Scalars['Int']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  availableStock?: Maybe<Scalars['Int']['output']>;
  availableWeekdays?: Maybe<Array<TicketAvailableWeekday>>;
  createdAt: Scalars['DateTime']['output'];
  currentPricePerPerson: Scalars['Int']['output'];
  dailyStock?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  expiryDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['String']['output']>;
  maxPartySize?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pricePerPerson: Scalars['Int']['output'];
  pricingTiers: Array<TicketPricingTier>;
  purchaseTimeEndMinutes?: Maybe<Scalars['Int']['output']>;
  purchaseTimeStartMinutes?: Maybe<Scalars['Int']['output']>;
  restaurant: Restaurant;
  shop: Shop;
  status: TicketPublicationStatus;
  updatedAt: Scalars['DateTime']['output'];
  validTimeEndMinutes?: Maybe<Scalars['Int']['output']>;
  validTimeStartMinutes?: Maybe<Scalars['Int']['output']>;
};


export type TicketDescriptionArgs = {
  lang?: InputMaybe<SupportedLanguage>;
};


export type TicketNameArgs = {
  lang?: InputMaybe<SupportedLanguage>;
};

export enum TicketAvailableWeekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type TicketConnection = {
  __typename?: 'TicketConnection';
  edges: Array<TicketEdge>;
  pageInfo: PageInfo;
};

export type TicketEdge = {
  __typename?: 'TicketEdge';
  cursor: Scalars['String']['output'];
  node: Ticket;
};

export type TicketPricingTier = {
  __typename?: 'TicketPricingTier';
  maxTicketNumber: Scalars['Int']['output'];
  minTicketNumber: Scalars['Int']['output'];
  pricePerPerson: Scalars['Int']['output'];
  upToQuantity: Scalars['Int']['output'];
};

export enum TicketPublicationStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export enum TicketStatus {
  Expired = 'EXPIRED',
  Used = 'USED',
  Valid = 'VALID'
}

export type TicketTextTranslationPreviewItem = {
  __typename?: 'TicketTextTranslationPreviewItem';
  description: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum TicketVerificationMethod {
  CodeInput = 'CODE_INPUT',
  QrCode = 'QR_CODE'
}

export type ToggleTicketActiveError = {
  __typename?: 'ToggleTicketActiveError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type ToggleTicketActiveResult = Ticket | ToggleTicketActiveError;

export type UpdateAdminSettingTermsError = {
  __typename?: 'UpdateAdminSettingTermsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateAdminSettingTermsInput = {
  privacyPolicy: Scalars['String']['input'];
  termsOfService: Scalars['String']['input'];
};

export type UpdateAdminSettingTermsResult = AdminSettingTerms | UpdateAdminSettingTermsError;

export type UpdateAdminUserError = {
  __typename?: 'UpdateAdminUserError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateAdminUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateAdminUserResult = AdminUser | UpdateAdminUserError;

export type UpdateCheckoutSessionTicketRecipientEmailError = {
  __typename?: 'UpdateCheckoutSessionTicketRecipientEmailError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateCheckoutSessionTicketRecipientEmailInput = {
  sessionId: Scalars['String']['input'];
  ticketRecipientEmail: Scalars['String']['input'];
};

export type UpdateCheckoutSessionTicketRecipientEmailResult = UpdateCheckoutSessionTicketRecipientEmailError | UpdateCheckoutSessionTicketRecipientEmailSuccess;

export type UpdateCheckoutSessionTicketRecipientEmailSuccess = {
  __typename?: 'UpdateCheckoutSessionTicketRecipientEmailSuccess';
  success: Scalars['Boolean']['output'];
};

export type UpdateMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<TenantMembershipRole>;
  status?: InputMaybe<TenantMemberStatus>;
};

export type UpdateShopSettingsInput = {
  buildingName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  operatingCompanyName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
  shopEmail?: InputMaybe<Scalars['String']['input']>;
  shopName?: InputMaybe<Scalars['String']['input']>;
  shopPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantMemberError = {
  __typename?: 'UpdateTenantMemberError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateTenantMemberResult = TenantMember | UpdateTenantMemberError;

export type UpdateTenantShopSettingsError = {
  __typename?: 'UpdateTenantShopSettingsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateTenantShopSettingsResult = Restaurant | UpdateTenantShopSettingsError;

export type UpdateTenantTicketError = {
  __typename?: 'UpdateTenantTicketError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateTenantTicketInput = {
  availableWeekdays?: InputMaybe<Array<TicketAvailableWeekday>>;
  dailyStock?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiryDays?: InputMaybe<Scalars['Int']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  maxPartySize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingTiers?: InputMaybe<Array<UpdateTenantTicketPricingTierInput>>;
  purchaseTimeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  purchaseTimeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TicketPublicationStatus>;
  ticketId: Scalars['ID']['input'];
  validTimeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  validTimeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTenantTicketPricingTierInput = {
  pricePerPerson: Scalars['Int']['input'];
  upToQuantity: Scalars['Int']['input'];
};

export type UpdateTenantTicketResult = Ticket | UpdateTenantTicketError;

export type UpdateTenantTicketSettingsError = {
  __typename?: 'UpdateTenantTicketSettingsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateTenantTicketSettingsResult = Shop | UpdateTenantTicketSettingsError;

export type UpdateTicketSettingsInput = {
  verificationCode?: InputMaybe<Scalars['String']['input']>;
  verificationMethod: TicketVerificationMethod;
};

export type UseGuestTicketWithCodeError = {
  __typename?: 'UseGuestTicketWithCodeError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UseGuestTicketWithCodeInput = {
  ticketAccessToken: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type UseGuestTicketWithCodeResult = Purchase | UseGuestTicketWithCodeError;

export type UseTicketWithCodeError = {
  __typename?: 'UseTicketWithCodeError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UseTicketWithCodeInput = {
  purchaseId: Scalars['ID']['input'];
  verificationCode: Scalars['String']['input'];
};

export type UseTicketWithCodeResult = Purchase | UseTicketWithCodeError;

export type SaveCardMutationVariables = Exact<{
  input: SaveCardInput;
}>;


export type SaveCardMutation = { __typename?: 'Mutation', saveCard:
    | { __typename?: 'SaveCardError', message: string }
    | { __typename?: 'SaveCardSuccess', cardId: string }
   };

export type AreaFilterAreasQueryVariables = Exact<{
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type AreaFilterAreasQuery = { __typename?: 'Query', areas: Array<{ __typename?: 'Area', id: string, label: string, prefectures: Array<{ __typename?: 'Prefecture', id: string, label: string }> }> };

export type DeleteAccountMutationVariables = Exact<{
  input: DeleteAccountInput;
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount:
    | { __typename?: 'DeleteAccountError', message: string }
    | { __typename?: 'DeleteAccountSuccess', success: boolean }
   };

export type CompleteGuestPurchaseTicketCheckoutMutationVariables = Exact<{
  input: CompleteGuestPurchaseTicketCheckoutInput;
}>;


export type CompleteGuestPurchaseTicketCheckoutMutation = { __typename?: 'Mutation', completeGuestPurchaseTicketCheckout:
    | { __typename?: 'CompleteGuestPurchaseTicketCheckoutError', code: ErrorCode, message: string }
    | { __typename?: 'CompleteGuestPurchaseTicketCheckoutSuccess', ticketAccessToken: string }
   };

export type CompletePurchaseTicketCheckoutMutationVariables = Exact<{
  input: CompletePurchaseTicketCheckoutInput;
}>;


export type CompletePurchaseTicketCheckoutMutation = { __typename?: 'Mutation', completePurchaseTicketCheckout:
    | { __typename?: 'CompletePurchaseTicketCheckoutError', code: ErrorCode, message: string }
    | { __typename?: 'Purchase', id: string }
   };

export type CreateGuestPurchaseCheckoutSessionMutationVariables = Exact<{
  input: CreateGuestPurchaseCheckoutSessionInput;
}>;


export type CreateGuestPurchaseCheckoutSessionMutation = { __typename?: 'Mutation', createGuestPurchaseCheckoutSession:
    | { __typename?: 'CreateGuestPurchaseCheckoutSessionError', code: ErrorCode, message: string }
    | { __typename?: 'CreateGuestPurchaseCheckoutSessionSuccess', sessionId: string, clientSecret: string }
   };

export type CreatePurchaseCheckoutSessionMutationVariables = Exact<{
  input: CreatePurchaseCheckoutSessionInput;
}>;


export type CreatePurchaseCheckoutSessionMutation = { __typename?: 'Mutation', createPurchaseCheckoutSession:
    | { __typename?: 'CreatePurchaseCheckoutSessionError', code: ErrorCode, message: string }
    | { __typename?: 'CreatePurchaseCheckoutSessionSuccess', sessionId: string, clientSecret: string }
   };

export type GetPurchaseContextQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type GetPurchaseContextQuery = { __typename?: 'Query', me: { __typename?: 'Me', id: string, email: string, savedCards: Array<{ __typename?: 'SavedCard', id: string, brand: string, last4: string, expiryMonth: number, expiryYear: number }> }, ticket: { __typename?: 'Ticket', id: string, name: string, description: string, imageUrls: Array<string>, currentPricePerPerson: number, restaurant: { __typename?: 'Restaurant', id: string, shop: { __typename?: 'Shop', name: string, prefecture: string, city: string, streetAddress: string, buildingName?: string | null, phoneNumber: string } } } };

export type GuestPurchaseCheckoutSessionStatusQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type GuestPurchaseCheckoutSessionStatusQuery = { __typename?: 'Query', guest: { __typename?: 'Guest', purchaseCheckoutSessionStatus:
      | { __typename?: 'GuestPurchaseCheckoutSessionStatus', sessionId: string, status?: string | null, paymentStatus: string, clientSecret?: string | null, ticketAccessToken?: string | null }
      | { __typename?: 'GuestPurchaseCheckoutSessionStatusError', code: ErrorCode, message: string }
     } };

export type PurchaseCheckoutSessionStatusQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type PurchaseCheckoutSessionStatusQuery = { __typename?: 'Query', purchaseCheckoutSessionStatus:
    | { __typename?: 'PurchaseCheckoutSessionStatus', sessionId: string, status?: string | null, paymentStatus: string, clientSecret?: string | null, purchaseId?: string | null }
    | { __typename?: 'PurchaseCheckoutSessionStatusError', code: ErrorCode, message: string }
   };

export type UpdateCheckoutSessionTicketRecipientEmailMutationVariables = Exact<{
  input: UpdateCheckoutSessionTicketRecipientEmailInput;
}>;


export type UpdateCheckoutSessionTicketRecipientEmailMutation = { __typename?: 'Mutation', updateCheckoutSessionTicketRecipientEmail:
    | { __typename?: 'UpdateCheckoutSessionTicketRecipientEmailError', code: ErrorCode, message: string }
    | { __typename?: 'UpdateCheckoutSessionTicketRecipientEmailSuccess', success: boolean }
   };

export type GetSavedCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedCardsQuery = { __typename?: 'Query', me: { __typename?: 'Me', savedCards: Array<{ __typename?: 'SavedCard', id: string, brand: string, last4: string, expiryMonth: number, expiryYear: number }> } };

export type DeleteSavedCardsMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteSavedCardsMutation = { __typename?: 'Mutation', deleteSavedCards:
    | { __typename?: 'DeleteSavedCardsError', message: string }
    | { __typename?: 'DeleteSavedCardsSuccess', success: boolean }
   };

export type AccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountInfoQuery = { __typename?: 'Query', me: { __typename?: 'Me', id: string, email: string, savedCards: Array<{ __typename?: 'SavedCard', id: string, last4: string, brand: string, expiryMonth: number, expiryYear: number }> } };

export type GetGuestPurchaseCheckoutContextQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type GetGuestPurchaseCheckoutContextQuery = { __typename?: 'Query', ticket: { __typename?: 'Ticket', id: string, name: string, description: string, pricePerPerson: number, imageUrls: Array<string>, restaurant: { __typename?: 'Restaurant', shop: { __typename?: 'Shop', name: string } } } };

export type UseGuestTicketWithCodeMutationVariables = Exact<{
  input: UseGuestTicketWithCodeInput;
}>;


export type UseGuestTicketWithCodeMutation = { __typename?: 'Mutation', useGuestTicketWithCode:
    | { __typename: 'Purchase', id: string }
    | { __typename: 'UseGuestTicketWithCodeError', code: ErrorCode, message: string }
   };

export type GetTicketByTokenQueryVariables = Exact<{
  ticketAccessToken: Scalars['String']['input'];
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type GetTicketByTokenQuery = { __typename?: 'Query', guest: { __typename?: 'Guest', purchasedTicket: { __typename?: 'Purchase', id: string, referenceCode: string, quantity: number, purchasedAt: Date, totalAmount: number, expiresAt: Date, usedAt?: Date | null, status: PurchaseStatus, customerEmail: string, ticket: { __typename?: 'Ticket', id: string, name: string, description: string, validTimeStartMinutes?: number | null, validTimeEndMinutes?: number | null, imageUrls: Array<string>, restaurant: { __typename?: 'Restaurant', id: string, shop: { __typename?: 'Shop', name: string, verificationMethod: TicketVerificationMethod } } } } } };

export type PurchaseDetailQueryVariables = Exact<{
  purchaseId: Scalars['ID']['input'];
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type PurchaseDetailQuery = { __typename?: 'Query', me: { __typename?: 'Me', purchasedTicket?: { __typename?: 'Purchase', id: string, referenceCode: string, quantity: number, totalAmount: number, purchasedAt: Date, expiresAt: Date, status: PurchaseStatus, customerEmail: string, usedAt?: Date | null, ticket: { __typename?: 'Ticket', id: string, name: string, description: string, validTimeStartMinutes?: number | null, validTimeEndMinutes?: number | null, imageUrls: Array<string>, restaurant: { __typename?: 'Restaurant', id: string, shop: { __typename?: 'Shop', name: string, prefecture: string, city: string, streetAddress: string, buildingName?: string | null, phoneNumber: string } } } } | null } };

export type PurchaseHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type PurchaseHistoryQuery = { __typename?: 'Query', me: { __typename?: 'Me', purchasedTickets: { __typename?: 'PurchaseConnection', edges: Array<{ __typename?: 'PurchaseEdge', node: { __typename?: 'Purchase', id: string, quantity: number, totalAmount: number, purchasedAt: Date, expiresAt: Date, status: PurchaseStatus, usedAt?: Date | null, ticket: { __typename?: 'Ticket', id: string, name: string, imageUrls: Array<string>, restaurant: { __typename?: 'Restaurant', id: string, shop: { __typename?: 'Shop', name: string } } } } }>, pageInfo: { __typename?: 'PurchasePageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type UseTicketWithCodeMutationVariables = Exact<{
  input: UseTicketWithCodeInput;
}>;


export type UseTicketWithCodeMutation = { __typename?: 'Mutation', useTicketWithCode:
    | { __typename: 'Purchase', id: string }
    | { __typename: 'UseTicketWithCodeError', code: ErrorCode, message: string }
   };

export type TicketPresentationQueryVariables = Exact<{
  purchaseId: Scalars['ID']['input'];
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type TicketPresentationQuery = { __typename?: 'Query', me: { __typename?: 'Me', purchasedTicket?: { __typename?: 'Purchase', id: string, referenceCode: string, quantity: number, purchasedAt: Date, totalAmount: number, expiresAt: Date, usedAt?: Date | null, status: PurchaseStatus, customerEmail: string, ticket: { __typename?: 'Ticket', id: string, name: string, validTimeStartMinutes?: number | null, validTimeEndMinutes?: number | null, restaurant: { __typename?: 'Restaurant', id: string, shop: { __typename?: 'Shop', name: string, verificationMethod: TicketVerificationMethod } } } } | null } };

export type RestaurantTicketsQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type RestaurantTicketsQuery = { __typename?: 'Query', restaurant: { __typename?: 'Restaurant', id: string, shop: { __typename?: 'Shop', name: string }, tickets: Array<{ __typename?: 'Ticket', id: string, name: string, description: string, currentPricePerPerson: number, imageUrls: Array<string>, availableStock?: number | null, purchaseTimeStartMinutes?: number | null, purchaseTimeEndMinutes?: number | null, restaurant: { __typename?: 'Restaurant', id: string, shop: { __typename?: 'Shop', name: string } } }> } };

export type RestaurantTicketDetailQueryVariables = Exact<{
  restaurantId: Scalars['ID']['input'];
  ticketId: Scalars['ID']['input'];
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type RestaurantTicketDetailQuery = { __typename?: 'Query', ticket: { __typename?: 'Ticket', id: string, name: string, description: string, currentPricePerPerson: number, imageUrls: Array<string>, availableStock?: number | null, maxPartySize?: number | null, validTimeStartMinutes?: number | null, validTimeEndMinutes?: number | null, purchaseTimeStartMinutes?: number | null, purchaseTimeEndMinutes?: number | null, restaurant: { __typename?: 'Restaurant', id: string, operatingCompanyName: string, shop: { __typename?: 'Shop', name: string } } } };

export type BrowseTicketsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  areaId?: InputMaybe<Scalars['ID']['input']>;
  lang?: InputMaybe<SupportedLanguage>;
}>;


export type BrowseTicketsQuery = { __typename?: 'Query', tickets: { __typename?: 'TicketConnection', edges: Array<{ __typename?: 'TicketEdge', node: { __typename?: 'Ticket', id: string, name: string, description: string, currentPricePerPerson: number, imageUrls: Array<string>, availableStock?: number | null, maxPartySize?: number | null, purchaseTimeStartMinutes?: number | null, purchaseTimeEndMinutes?: number | null, restaurant: { __typename?: 'Restaurant', id: string, operatingCompanyName: string, shop: { __typename?: 'Shop', name: string }, tickets: Array<{ __typename?: 'Ticket', id: string }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };


export const SaveCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveCardInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SaveCardSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SaveCardError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SaveCardMutation, SaveCardMutationVariables>;
export const AreaFilterAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AreaFilterAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"prefectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}]}}]}}]}}]} as unknown as DocumentNode<AreaFilterAreasQuery, AreaFilterAreasQueryVariables>;
export const DeleteAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAccountSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteAccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const CompleteGuestPurchaseTicketCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteGuestPurchaseTicketCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteGuestPurchaseTicketCheckoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeGuestPurchaseTicketCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteGuestPurchaseTicketCheckoutSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticketAccessToken"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteGuestPurchaseTicketCheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CompleteGuestPurchaseTicketCheckoutMutation, CompleteGuestPurchaseTicketCheckoutMutationVariables>;
export const CompletePurchaseTicketCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompletePurchaseTicketCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompletePurchaseTicketCheckoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completePurchaseTicketCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CompletePurchaseTicketCheckoutError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CompletePurchaseTicketCheckoutMutation, CompletePurchaseTicketCheckoutMutationVariables>;
export const CreateGuestPurchaseCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGuestPurchaseCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGuestPurchaseCheckoutSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGuestPurchaseCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGuestPurchaseCheckoutSessionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGuestPurchaseCheckoutSessionError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateGuestPurchaseCheckoutSessionMutation, CreateGuestPurchaseCheckoutSessionMutationVariables>;
export const CreatePurchaseCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePurchaseCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePurchaseCheckoutSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPurchaseCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePurchaseCheckoutSessionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePurchaseCheckoutSessionError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePurchaseCheckoutSessionMutation, CreatePurchaseCheckoutSessionMutationVariables>;
export const GetPurchaseContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPurchaseContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"savedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"restaurantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ticketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"currentPricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prefecture"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPurchaseContextQuery, GetPurchaseContextQueryVariables>;
export const GuestPurchaseCheckoutSessionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GuestPurchaseCheckoutSessionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseCheckoutSessionStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GuestPurchaseCheckoutSessionStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"ticketAccessToken"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GuestPurchaseCheckoutSessionStatusError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GuestPurchaseCheckoutSessionStatusQuery, GuestPurchaseCheckoutSessionStatusQueryVariables>;
export const PurchaseCheckoutSessionStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PurchaseCheckoutSessionStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseCheckoutSessionStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseCheckoutSessionStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"paymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseCheckoutSessionStatusError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PurchaseCheckoutSessionStatusQuery, PurchaseCheckoutSessionStatusQueryVariables>;
export const UpdateCheckoutSessionTicketRecipientEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCheckoutSessionTicketRecipientEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCheckoutSessionTicketRecipientEmailInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCheckoutSessionTicketRecipientEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCheckoutSessionTicketRecipientEmailSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCheckoutSessionTicketRecipientEmailError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCheckoutSessionTicketRecipientEmailMutation, UpdateCheckoutSessionTicketRecipientEmailMutationVariables>;
export const GetSavedCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSavedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}}]}}]}}]}}]} as unknown as DocumentNode<GetSavedCardsQuery, GetSavedCardsQueryVariables>;
export const DeleteSavedCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSavedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSavedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSavedCardsSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSavedCardsError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSavedCardsMutation, DeleteSavedCardsMutationVariables>;
export const AccountInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"savedCards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}}]}}]}}]}}]} as unknown as DocumentNode<AccountInfoQuery, AccountInfoQueryVariables>;
export const GetGuestPurchaseCheckoutContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGuestPurchaseCheckoutContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"restaurantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ticketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"pricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetGuestPurchaseCheckoutContextQuery, GetGuestPurchaseCheckoutContextQueryVariables>;
export const UseGuestTicketWithCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UseGuestTicketWithCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UseGuestTicketWithCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"useGuestTicketWithCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UseGuestTicketWithCodeError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UseGuestTicketWithCodeMutation, UseGuestTicketWithCodeMutationVariables>;
export const GetTicketByTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTicketByToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketAccessToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchasedTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ticketAccessToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketAccessToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"validTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMethod"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTicketByTokenQuery, GetTicketByTokenQueryVariables>;
export const PurchaseDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PurchaseDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchasedTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"validTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"prefecture"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PurchaseDetailQuery, PurchaseDetailQueryVariables>;
export const PurchaseHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PurchaseHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchasedTickets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PurchaseHistoryQuery, PurchaseHistoryQueryVariables>;
export const UseTicketWithCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UseTicketWithCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UseTicketWithCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"useTicketWithCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Purchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UseTicketWithCodeError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UseTicketWithCodeMutation, UseTicketWithCodeMutationVariables>;
export const TicketPresentationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TicketPresentation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"purchaseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchasedTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"purchaseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"referenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"validTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMethod"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TicketPresentationQuery, TicketPresentationQueryVariables>;
export const RestaurantTicketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RestaurantTickets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"currentPricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"availableStock"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RestaurantTicketsQuery, RestaurantTicketsQueryVariables>;
export const RestaurantTicketDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RestaurantTicketDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ticket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"restaurantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ticketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"currentPricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"availableStock"}},{"kind":"Field","name":{"kind":"Name","value":"maxPartySize"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"operatingCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RestaurantTicketDetailQuery, RestaurantTicketDetailQueryVariables>;
export const BrowseTicketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BrowseTickets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupportedLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"areaId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"areaId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]},{"kind":"Field","name":{"kind":"Name","value":"currentPricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"availableStock"}},{"kind":"Field","name":{"kind":"Name","value":"maxPartySize"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"operatingCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tickets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<BrowseTicketsQuery, BrowseTicketsQueryVariables>;